<template lang='pug'>
  .base-card.component
    slot
</template>

<script>
  import { db } from '@/main'

  export default {
    name: 'base-card.component'
  }
</script>

<style scoped lang='stylus'>
  .base-card
    border 1px solid rgb( 220 220 220 )
    border-radius 5px
    box-shadow var(--shadow-card)
    overflow hidden
    background white
    
  .base-card.padded
    padding 16px

  .base-card.padded.roomy
    padding 15px

  .base-card.overflowable
    overflow visible
</style>
